const pagesIndividualRequestEn = {
  categories: {
    contractorCore: 'Contractor Core',
    gaOperationCore: 'GA Operation Core',
    itOperationCore: 'IT Operation Core',
    laborCore: 'Labor Core'
  },
  emptyState: {
    description: 'Currently, there are no requests or notifications available. If new ones become available, they will be displayed in this section.',
    title: 'No requests or notifications available'
  },
  title: 'Request'
};
export default pagesIndividualRequestEn;